<form [formGroup]="loginForm" class="relative overflow-visible pt-2">
  <div class="flex flex-row h-48">
    <div class="w-full">
      <div
        class="form-input py-1 mb-2"
        [ngClass]="{ 'has-error': loginForm.controls['email'].errors && loginForm.controls['email'].touched }"
      >
        @if (!(loginForm.controls['email'].errors && loginForm.controls['email'].touched)) {
          <label>Email Address</label>
        } @else {
          <label>
            <ion-icon name="alert-circle" class="text-base"></ion-icon>
            @if (loginForm.controls['email'].errors['required']) {
              <span>Email Address is required</span>
            }
          </label>
        }
        <input
          #email
          autocomplete="username"
          id="email"
          type="text"
          formControlName="email"
          (focus)="loginForm.controls['email'].markAsUntouched()"
          autofocus
        />
      </div>
      <div
        class="form-input py-1 mb-8"
        [ngClass]="{ 'has-error': loginForm.controls['password'].errors && loginForm.controls['password'].touched }"
      >
        @if (!(loginForm.controls['password'].errors && loginForm.controls['password'].touched)) {
          <label>Password</label>
        } @else {
          <label>
            <ion-icon name="alert-circle" class="text-base"></ion-icon>
            @if (loginForm.controls['password'].errors['required']) {
              <span>Password is required</span>
            }
          </label>
        }
        <input
          autocomplete="current-password"
          id="password"
          type="password"
          formControlName="password"
          (focus)="loginForm.controls['password'].markAsUntouched()"
          (keyup.enter)="submitLogin()"
        />
      </div>
    </div>
  </div>
</form>
<div class="mt-2 flex flex-col items-center justify-between gap-1">
  <button id="submit" (click)="submitLogin()" class="my-2 block w-full">Continue</button>
  <a
    id="forgot-password"
    routerLink="/forgot-password"
    class="inline-block btn-link p-2 text-primary text-center font-medium"
    >Forgot Password?
  </a>
</div>
